// extracted by mini-css-extract-plugin
module.exports = {"meal":"MealItem_meal__13hHZ","description":"MealItem_description__2PlTx","price":"MealItem_price__1HpAv"};